"use strict";
function isObject(x) {
    return x != null && typeof x === 'object';
}
exports.isObject = isObject;
//# sourceMappingURL=isObject.js.map


//////////////////
// WEBPACK FOOTER
// ./${exlibris_product}/npm_modules/May2025-PROD/prima/node_modules/rxjs/util/isObject.js
// module id = 311
// module chunks = 6